"use strict";

const Misc = () => {
    const init = () => {
        $(function() {
            var $buttons = $('.js-load-more-button');
            if ($buttons.length > 0) {
                $buttons.on('click', function(){
                    var $button = $(this);
                    var $content = $button.siblings('.js-load-more-content');
                    $content.css('height', 'auto');
                    var height = $content.outerHeight();
                    $content.css('height', '');
                    $content.animate({'height': height+'px'}, function(){
                        $content.css('height', 'auto');
                        $button.remove();
                    });
                });
            }

            var $buttons = $('.js-view-all-button');
            if ($buttons.length > 0) {
                $buttons.on('click', function(){
                    var $button = $(this);
                    var $content = $button.parents('.js-view-all-content');
                    $content.addClass('loaded');
                    $button.remove();
                });
            }

            var $buttons = $('.js-scroll-to-next-section');
            if ($buttons.length > 0) {
                $buttons.on('click', function(){
                    var $button = $(this);
                    var $next = $button.parent().next();
                    if($next){
                        $('html, body').animate({
                            scrollTop: $next.offset().top
                        }, 100);
                    }
                });
            }

            var $buttons = $('.js-scroll-to');
            if ($buttons.length > 0) {
                $buttons.on('click', function(){
                    var $button = $(this);
                    var $targetData = $button.data('target');
                    var $target = $($targetData).first()
                    if ($button.data('target-last') == true) {
                        $target = $($targetData).last()
                    }

                    var $targetScrollPosition = parseInt($target.offset().top)

                    $('html, body').animate({
                        scrollTop: $targetScrollPosition,
                    });
                });
            }

            var $scrollToTop = $('.js-scroll-to-top');
            if ($scrollToTop.length > 0) {
                $scrollToTop.on('click', function(){
                    $('html, body').animate({
                        scrollTop: 0
                    }, 100);
                });

                $(window).on('scroll', function(){
                    if($(this).scrollTop() > $(window).height()){
                        $scrollToTop.addClass('active');
                    }else{
                        $scrollToTop.removeClass('active');
                    }
                });
            }

            if(window.location.hash){
                if(window.location.hash == '#display-locations'){
                    $('html, body').animate({
                        scrollTop: $('.module-display-locations').offset().top
                    }, 100);
                }
            }

            if($('body').data('cookie-state') === undefined && ($('body').data('state') == 'nsw' || $('body').data('state') == 'qld')){
                if($('body').data('state') == 'qld'){
                    if (navigator.geolocation) {
                        function success(position){
                            if(position.coords.latitude < -29.2){
                                //user is in NSW but has landed on a QLD page
                                $('.js-popout[data-hash="wrong-state-popout"]').addClass('open');
                            }
                        };
                        function error(position){
                            console.log(position);
                        };
                        navigator.geolocation.getCurrentPosition(success, error);
                    }
                }
            }

            var $hoverable = $('.js-hoverable');
            if ($hoverable.length > 0) {
                $hoverable.on('mouseenter', function(){
                    let $text = $(this).find('.js-hover-text');
                    $text.stop().slideDown();
                });
                $hoverable.on('mouseleave', function(){
                    let $text = $(this).find('.js-hover-text');
                    $text.stop().slideUp();
                });
            }
        });
    };

    return {
        init:init
    };
};

export default Misc;